import { Fragment, useState } from "react";
import {  SiteData } from "../Data/SiteData";
import { AttributeDefinition, AttributeInputType, AttributeTargetType } from "../Data/WBData";
import { AttributeCollection, getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import ColorInputField from "../StyleInputs/ColorInputField";
import { ScreenSize } from  "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { MapInputsFromEditList } from "../Stylebuilder";
import { ColorContrastRatio } from "vagaro-website-rendering/src/components/Utilities/ColorMath";
import ReactDOM, { unmountComponentAtNode } from "react-dom";
import VGPopUp from "vagaro-website-rendering/src/components/Controls/VGPopUp";
import XIcon from "vagaro-website-rendering/src/components/Icons/XIcon";
import { OpenColorPalletPopup } from "components/SetLibrary/ColorPalletePopUp";

export const ColorLabels =[
    "Darkest",
    "Dark",
    "Medium",
    "Light",
    "Lightest",
    "White",
    "Light Gray",
    "Medium Gray",
    "Dark Gray",
    "Black",
]

const defaultColors = [
    
        "#242424",//darkest
        "#383838",//dark
        "#BEBEBE",//medium
        "#E9E9E9",//light
        "#F6F6F6",//lightest
        "#FFFFFF",//white
        "#D5D5D5",//light gray
        "#868686",//medium gray
        "#464646",//dark gray
        "#000000"//black


  
]

export default function ColorPalleteMenu({siteData,hideTitle,saveFunc}:{siteData:SiteData,hideTitle?:boolean,saveFunc:Function}){

    const [toggleUpdate,update] = useState(false);
const onSave = ()=>{
    update(!toggleUpdate);
    saveFunc();
}

return    <>
    {!hideTitle&&<>
    <PageColorMenu siteData={siteData} saveFunc={onSave}/>
    <h2 className="panel-heading">Color Palette</h2>
    
        <button className="invisible-button w-full" style={{margin:"0 0 24px 0",padding:"10px 16px",borderRadius:"3px",color:"white",background:"linear-gradient(93.82deg, #FB5757 -4.64%, #F69B59 14.24%, #5EC555 51.42%, #5894DB 70.87%, #B958DB 100.04%)"}}
        
        onClick={()=>{
            OpenColorPalletPopup(siteData,(colors:string[])=>{

                let allColors = [...defaultColors];
           
                for(let i = 0;i<colors.length;i++){
                    allColors[i] = colors[i];
                }

                siteData.siteStyling.colorPallet = allColors;
                siteData.onUpdateStyle();
                onSave();
               


            });
        }}
        >Preset Color Palettes</button>


    </>
    }
    <div>

    {
        siteData.siteStyling.colorPallet.map((color,index)=>{
            return <RenderPalletLine key = {index+toggleUpdate.toString()} index={index} siteData={siteData}/>
        })
    }
        
  
    </div>
    <br />
    {
        siteData.userContext.isAdmin&&
        <button className="menu-button" onClick={()=>{OpenADAPopup(siteData)}}>Check ADA Compliance</button>
    }

    <button className="menu-button " onClick={()=>{FlipColors(siteData);onSave(); siteData.onUpdateStyle();}}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" height="1em"><path d="M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM400 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-258 0c0-63.1 51.6-114 115-114c3.3 0 6.5 .1 9.7 .4c7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-22.9 12.8-38.3 37.1-38.3 64.8c0 41 33.6 74.5 75.4 74.5c4.4 0 8.8-.4 13-1.1c6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-20.7 19.9-49 32.2-80.1 32.2c-63.4 0-115-50.9-115-114z"/></svg>
        
       Swap Light & Dark</button>
  </>


}



function RenderPalletLine({index,siteData}:{index:number,siteData:SiteData}){
    const clrDef = new AttributeDefinition("color","Color","",AttributeInputType.ColorField,[],null,AttributeTargetType.Component);
    let clr = siteData.siteStyling.colorPallet[index];

    let collection = new AttributeCollection();
    setNodeComponentAttributeValue(collection,"color",clr);

    const onUpdate = (attribute:string,value:string,targetType:AttributeTargetType)=>{
        setNodeComponentAttributeValue(collection,"color",value);
        siteData.siteStyling.colorPallet[index] = value;
        siteData.onUpdateStyle();
    
    }

    return  <ColorInputField label={ColorLabels[index]} definition={clrDef} updateFunc={onUpdate} saveFunc={() => { } } screenSize={ScreenSize.Desktop} siteData={siteData} layoutObject={collection} hidePallet={true}/>
       
}

export function OpenADAPopup(siteData:SiteData){

    let dom = document.getElementById("OpenDialog2");
    const PopupClose = () => {
        let dom = document.getElementById("OpenDialog2");
        if (dom) unmountComponentAtNode(dom);
        siteData.designer?.forceUpdate();
       
    };

    if(dom)
    ReactDOM.render(
        <>
        <VGPopUp
          id={"ada-color-cehck-popup"}
          show={true}
          onHide={PopupClose}
          title={"ADA Compliance Check"}
          dialogClassName="block-edit"
          body={
            <div className="alertContent">
                <ADAComboChart siteData={siteData}/>
            </div>
          }
          footer={
            <Fragment>
             
            <button className="w-button w-button-primary" onClick={(e) => { PopupClose();}}>Okay</button>
            </Fragment >
          }
          isRemoveTabModalIndex={false}
          isShowFooter={true}
          size={"modal-md"}
          backdrop={true}
        />
  
        </>,
        dom);

}

function FlipColors(siteData:SiteData){

    let siteStyling = siteData.siteStyling;
    let colors = siteData.siteStyling.colorPallet;

    let oldColors = [...colors];
    let darkThroughLight = oldColors.slice(0,5).reverse();
    let grays = oldColors.slice(5,10).reverse();
    siteData.siteStyling.colorPallet = [...darkThroughLight,...grays];

    let pageColor  = getNodeComponentAttributeValue(siteStyling.pageColor,"pageColor","#ffffff");
    const fColor = getNodeComponentAttributeValue(siteStyling.pageColor,"pageFontColor","#000000");

    if(!pageColor.includes("--theme")&&!fColor.includes("--theme")){ // only swap non themed page and font colors, otherwise leave them alone and let theme colors manage the switch
        setNodeComponentAttributeValue(siteStyling.pageColor,"pageColor",fColor);
        setNodeComponentAttributeValue(siteStyling.pageColor,"pageFontColor",pageColor);
    }


}

function PageColorMenu({siteData,saveFunc}:{siteData:SiteData,saveFunc:Function}){


    const updateAtt = (  attribute: string, value: string, targetType: AttributeTargetType) =>{
          
       const att = siteData.siteStyling.pageColor;

        setNodeComponentAttributeValue(att,attribute,value);
        siteData.onUpdateStyle();
       
        }



        return(
            <>
               <h2 className="panel-heading">Base Website Color</h2>
            
               <MapInputsFromEditList
               
                 editList={["pageColor","pageFontColor"]}
                 layoutNode={
                    siteData.siteStyling.pageColor
                 }
                 screenSize={ScreenSize.Desktop}
                 updateFunc={updateAtt}
                 saveFunc={ saveFunc}
                 showScreenSize={false}
                 siteData={siteData}
               />

    
              
             </>
    )
 }

export type ColorRatioPair =    {ratio:number,colorA:string,labelA:string,colorB:string,labelB:string};

export function GetADACombinations(siteData:SiteData){

    const compliant:ColorRatioPair[] = [];
    const semiCompliant:ColorRatioPair[] = [];
    const nonCompliant:ColorRatioPair[] = [];



    for(let i = 0;i<siteData.siteStyling.colorPallet.length;i++){
        for(let j = i+1;j<siteData.siteStyling.colorPallet.length;j++){
            const clrA = siteData.siteStyling.colorPallet[i];
            const clrB = siteData.siteStyling.colorPallet[j];
            if(clrA&&clrB){
             
                const pair = {ratio:ColorContrastRatio(clrA,clrB),colorA:clrA,colorB:clrB,labelA:ColorLabels[i],labelB:ColorLabels[j]};
                if(pair.ratio>=4.5){
                    compliant.push(pair);
                }
                else if(pair.ratio>=3){
                    semiCompliant.push(pair);
                }
                else{
                    nonCompliant.push(pair);
                }
            }
        }

    }

    return {
        compliant:compliant,
        semiCompliatn:semiCompliant,
        nonCompliant:nonCompliant
    }
}


 function ADAComboChart({siteData}:{siteData:SiteData}){

    const result = GetADACombinations(siteData);

    const compliant:ColorRatioPair[] = result.compliant;
    const semiCompliatn:ColorRatioPair[] = result.semiCompliatn;
    const nonCompliant:ColorRatioPair[] = result.nonCompliant;






    const RenderRaitoPair = ({pair}:{pair:ColorRatioPair})=>{

        

        return <div className="color-pair flex-column gap-small" style={{padding:"12px 8px",width:"33.33332%"}} >
            <div className="flex-row justify-center">
                <div className="color-pair-color flex-center" style={{backgroundColor:pair.colorA,width:"60px",height:"32px",borderRadius:"50px 0 0 50px",border:"1px solid #ccc",borderWidth:"1px 0px 1px 1px"}} ></div>
                <div className="color-pair-color flex-center" style={{backgroundColor:pair.colorB,width:"60px",height:"32px",borderRadius:"0 50px 50px 0",border:"1px solid #ccc",borderWidth:"1px 1px 1px 0px"}}></div>
            </div>
            <div className="font-small" style={{color:"777",textAlign:"center",whiteSpace:"nowrap"}}> {pair.labelA+" "} <span style={{opacity:".7"}}> & </span>{" "+pair.labelB}</div>
        </div>
    }

  
     return <div className="color-pair-container" >
         <br />
         <h5 className="flex-row gap-med">
             <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="#3e8438"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
             Compliant Color Combinations</h5>
         <p style={{ opacity: ".8",paddingLeft:"28px" }}>These color combinations are compliant with any font size</p>
         <div className="flex-row flex-wrap">
             {compliant.map((pair, index) => {
                 return <RenderRaitoPair key={index} pair={pair} />
             })}
         </div>
         <hr className="font-med" />
         <h5 className="flex-row gap-med">
         <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="#ffb300"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>
         Semi-Compliant Color Combinations</h5>
         <p style={{ opacity: ".8",paddingLeft:"28px" }}>These color combinations are compliant with larger font sizes</p>
         <div className="flex-row flex-wrap">
             {semiCompliatn.map((pair, index) => {
                 return <RenderRaitoPair key={index} pair={pair} />
             })}
         </div>
  
         <hr className="font-med" />
     
         <h5 className="flex-row gap-med">
             <div className="center-all" style={{ color: "red" }}><XIcon /></div>
             Non-Compliant Color Combinations</h5>
         <p style={{ opacity: ".8",paddingLeft:"28px" }}>These colors combinations are not compliant</p>
         <div className="flex-row flex-wrap ">
             {nonCompliant.map((pair, index) => {
                 return <RenderRaitoPair key={index} pair={pair} />
             })}
         </div>
     </div>

 }




